<template>
    <div>
      <div class="comment-head">
        <p>好评度 : {{averageRating}}</p>
        <!--<p class="c-go">我要评论<img src="../assets/image/message.png"></p>-->
      </div>
      <div class="comment-btn">
        <div>
          <p>全部</p>
          <p>({{totalCount}})</p>
        </div>
        <div>
          <p>好评</p>
          <p>({{rating1}})</p>
        </div>
        <div>
          <p>中评</p>
          <p>({{rating1}})</p>
        </div>
        <div>
          <p>差评</p>
          <p>({{rating1}})</p>
        </div>
      </div>
      <template v-for='review in reviews'>
        <comment :review='review'></comment>
      </template>
    </div>
</template>
<style scoped lang="less">
.comment-head {
  position: relative;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 18px;
  color: #585858;
  .c-go {
    position: absolute;
    right: 18px;
    top: 0;
    display: flex;
    align-items: center;
    color: #3493f3;
    font-size: 12px;
    img {
      width: 14px;
      margin-left: 4px;
    }
  }
}
.comment-btn {
  height: 55px;
  color: #585858;
  font-size: 12px;
  text-align: center;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
}
</style>
<script>
    import Comment from './common/CommentComponent.vue'
    export default{
        data(){
            return{
                api: this.$store.state.api,
                eightD: this.$route.query.eightD,
                averageRating: '',
                rating1: '',
                rating2: '',
                rating3: '',
                rating4: '',
                rating5: '',
                totalCount: '',
                reviews: []
            }
        },
        components:{
            Comment,
        },
        created() {
          this.getReviews();
        },
        methods: {
          getReviews() {
              let url = this.api.review.getProductReviews();
              this.$http.post(url,JSON.stringify({
                product8D:this.eightD
              }))
              .then(res => {
                if(res.data.resultMsg[0].code=='00'&&res.data.resultMsg[0].message=='Success') {
                  var overallReviewStatus = res.data.resultData.overallReviewStatus;
                  var reviews = res.data.resultData.reviews;

                  if(overallReviewStatus){
                    this.averageRating = overallReviewStatus.averageRating;
                    this.totalCount = overallReviewStatus.totalCount;
                    this.rating1 = overallReviewStatus.rating1;
                    this.rating2 = overallReviewStatus.rating2;
                    this.rating3 = overallReviewStatus.rating3;
                    this.rating4 = overallReviewStatus.rating4;
                    this.rating5 = overallReviewStatus.rating5;
                  }
                  if(reviews){
                    this.reviews = reviews;
                  }
                }
              });
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/AllComment.vue